module.exports = __webpack_public_path__ + "img/k.a6e49f1c.jpg";